export default __webpack_public_path__ + "static/media/480_store04-jp-web.b6da8e8c.png";